import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from "react-router-dom";
import styled from 'styled-components'
import SidebarMenu from '../SidebarMenu/SidebarMenu'
import SettingsSection from './Components/SettingsSection/SettingsSection'
import DownloadManagerSection from './Components/DownloadManagerSection/DownloadManagerSection'
import AvailableOfflineSection from './Components/AvailableOfflineSection/AvailableOfflineSection'
import FavoritesSection from './Components/FavoritesSection/FavoritesSection'
import isElectron from 'is-electron';
import { connect } from "react-redux";
import TicketsSection from "./Components/TicketsSection/TicketsSection"; // TODO
import { triggerProfileAnalytics } from "../../../../web/Utils/utils";

const Wrapper = styled.div`
    display: flex;
    margin-top: 75px;
`;

const Profile = ( props ) => {
    const canConnect = props.isNetworkAvailable //&& props.isServerReachable;
    const [ optionSelected, setOptionSelected ] = useState ( "settings" );
    const id = useParams ().id;
    const history = useHistory ();
    const { changeTitle } = props;

    useEffect ( () => {
        if ( id ) {
            if ( id !== optionSelected ) {
                setOptionSelected ( id );
            }
            if ( canConnect ) {
                triggerProfileAnalytics ( id )
            }
        } else {
            setOptionSelected ( "settings" )
            history.push ( "/profile/settings" )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const navigateTo = ( option ) => {
        if ( option !== optionSelected ) {
            setOptionSelected ( option );
            if ( canConnect ) {
                triggerProfileAnalytics ( option );
            }
            history.push ( "/profile/" + option );
        }
    }

    return (
        <Wrapper>
            <SidebarMenu
                optionSelected={ optionSelected }
                selectOption={ navigateTo }
            />
            {
                optionSelected === "settings" &&
                <SettingsSection changeTitle={ changeTitle }/>
            }
            {
                optionSelected === "tickets" &&
                <TicketsSection changeTitle={ changeTitle }/>
            }
            {
                optionSelected === "downloading" && isElectron () &&
                <DownloadManagerSection changeTitle={ changeTitle }/>
            }
            {
                optionSelected === "offline" && isElectron () &&
                <AvailableOfflineSection changeTitle={ changeTitle }/>
            }
            {
                optionSelected === "favorites" &&
                <FavoritesSection changeTitle={ changeTitle }/>
            }
        </Wrapper>
    )
}

const mapStateToProps = ( state ) => ( {
    session: state.session,
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
} )

export default connect ( mapStateToProps, {} ) ( Profile );